import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import image1 from './logo/logo.webp';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const typedElement = useRef(null);
  const menuRef = useRef(null);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(prevState => !prevState);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  // Handle body overflow
  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : 'auto';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMenuOpen]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !event.target.closest('.hamburger-btn')
      ) {
        closeMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  // Close menu on route change
  useEffect(() => {
    closeMenu();
  }, [location]);

  // ✅ FIXED Typed.js (lazy load → reduces TBT)
  useEffect(() => {
    let typed;

    import('typed.js').then((TypedModule) => {
      const Typed = TypedModule.default;

      typed = new Typed(typedElement.current, {
        strings: [
          'Pandit L. R. College of Technology',
          'Pt. L. R. College of Technology',
        ],
        typeSpeed: 50,
        backSpeed: 30,
        backDelay: 1500,
        loop: true,
          showCursor: false,

      });
    });

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      if (typed) typed.destroy();
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`header-main ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-top">
        <div className="header-content">

          {/* ✅ Logo Section FIXED */}
          <div className="logo-section">
            <Link to="/" onClick={closeMenu}>
              <img
                className="college-logo"
                src={image1}
                alt="Pandit L.R. College of Technology Logo"
                width="100"
                height="100"
              />
            </Link>
          </div>

          {/* College Info Section */}
          <div className="college-info-section">
            <h1 className="college-name-wrapper">
              <span ref={typedElement} className="college-name-typed"></span>
            </h1>
            <p className="college-tagline">
              Approved by AICTE | Affiliated to HSBTE | Affiliated to Maharishi Dayanand University
            </p>
          </div>

        </div>
      </div>
    </header>
  );
};

export default Header;